import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type {
  IApiUpdateAppSettingsRequestBody,
  IApiUpdateAppSettingsResponseBody,
} from './AppSettingsApi.types';

export class AppSettingsApi {
  public constructor(private client: ApiClient) {}

  public async update(
    appId: string,
    body: IApiUpdateAppSettingsRequestBody,
  ): Promise<IApiUpdateAppSettingsResponseBody> {
    const request: IApiJsonRequest = {
      path: `/apps/${appId}/settings`,
      method: 'patch',
      body,
    };

    const response =
      await this.client.fetchJson<IApiUpdateAppSettingsResponseBody>(request, {
        appId,
      });

    return response.body;
  }
}
